export { default } from "./ForgotPasswordWrapper.jsx";
